import { render } from "./ContextMenuIconCheck.vue?vue&type=template&id=f3b78eb6"
const script = {}

import exportComponent from "D:\\Code\\GitHub\\vue3-context-menu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__